import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {BrandHubPageService_GetStreamNextLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/brand_hub/v1/service.grpc.lazy';
import {
  useAnySession,
  useNavigationBackOptimizedBasketToken,
} from '@aboutyou/user';
import {
  useKeepPreviousData,
  useResetOnFetchEnd,
} from '../../../../features/ProductStream/utils';
import {useBrandShopCacheKeyTransformer} from '../../utils/useBrandShopIdentifier';

export const useBrandPageStreamNext = ({token}: {token: Uint8Array}) => {
  const session = useAnySession();

  const {keepPreviousData, resetOnFetchEnd} = useKeepPreviousData();
  const brandShopCacheKeyTransformer = useBrandShopCacheKeyTransformer();

  const {basketToken} = useNavigationBackOptimizedBasketToken({
    uniqueKey: 'brand_page_stream',
  });

  const request = useGrpcRequest(
    BrandHubPageService_GetStreamNextLazy,
    {
      session,
      streamState: token,
      basketToken,
    },
    {
      transformCacheKey: brandShopCacheKeyTransformer,
      keepPreviousData,
      retry: 1,
    },
  );

  useResetOnFetchEnd(request, resetOnFetchEnd);

  return request;
};
